Auth = require 'db/auth'
Survey = require('common/lib/survey').default
Token = require('common/lib/util/token').default

# This module manages showing appcues surveys to users. You can create
# a survey in appcues and call survey.show()
# and get results saved to atomic.com_trello_client_events_1, where you
# can query them in mode.

getDismissedSurveys = ->
  if me = Auth.me() then me.getDismissedSurveys() else []
dismissSurvey = (surveyId) ->
  if me = Auth.me() then me.dismissSurveyById(surveyId)
getIdentifier = ->
  Token.getMyId() or 'notLoggedIn'

args = [getDismissedSurveys, dismissSurvey, getIdentifier]

module.exports = {
  boardInviteesSurvey: new Survey(args..., '-LXKn1MXbPfhgURj1fw8', 1)
}



// WEBPACK FOOTER //
// ./app/scripts/lib/surveys/index.coffee